import { deleteFile, getAllData, getDataByID, postFile, postNew, updateData } from "../api/api";

import {
	CountryBrandApplication,
	defaultCountryBrandApplication,
} from "../domain/CountryBrandApplication";
import { CountryBrandApplicationRepository } from "../domain/CountryBrandApplicationRepository";

async function simulateRandomError() {
	const random = Math.random();
	await new Promise((r) => setTimeout(r, 1000));
	if (random > 0.5) {
		throw new Error("Error al crear la solicitud");
	}
}

class CountryBrandApplicationApiRepository implements CountryBrandApplicationRepository {
	async add(data: CountryBrandApplication): Promise<string> {
		const res = await postNew(JSON.stringify(data));
		if (res.ok) {
			const newData = await res.json();
			return newData.id;
		} else {
			throw new Error("Error al crear la solicitud");
		}
	}

	async getByID(id: string): Promise<CountryBrandApplication | null> {
		let countryBrandApplication = null;
		const res = await getDataByID(id);
		if (res.ok) {
			countryBrandApplication = await res.json();
		} else {
			countryBrandApplication = defaultCountryBrandApplication(id);
		}

		return countryBrandApplication;
	}

	async update(data: Partial<CountryBrandApplication>): Promise<Partial<CountryBrandApplication>> {
		const listAllFilesAddPromises: { applicationId: string; group: string; file: File }[] = [];
		const listAllFilesAddId: string[] = [];
		const listAllFilesDeletePromises: { applicationId: string; id: string }[] = [];
		data.attachments?.forEach(async (attach) => {
			if (attach.file && attach.file instanceof File && attach.status == "ADD") {
				listAllFilesAddId.push(attach.id);
				listAllFilesAddPromises.push(
					postFile({ applicationId: data.id, group: attach.type, file: attach.file })
				);
			}
			if (attach.status == "DELETE") {
				listAllFilesDeletePromises.push(deleteFile({ applicationId: data.id, id: attach.id }));
			}
		});
		await Promise.all(listAllFilesDeletePromises);
		const allAddFiles = await Promise.all(listAllFilesAddPromises);
		data.attachments = data.attachments?.filter((attach) => attach.status !== "DELETE");
		allAddFiles.forEach(async (e) => {
			const index = allAddFiles.indexOf(e);
			const file = data.attachments?.find((f) => f.id === listAllFilesAddId[index]);
			if (e.ok) {
				const res = await e.json();
				file.id = res.id;
				file.status = "READ";
				file.url = `${process.env.REACT_APP_API_SERVER_URL}/api/CountryBrandApplications/CountryBrandApplications/DownloadFile?id=${res.id}&applicationId=${data.id}`;
			}
		});
		const newData = structuredClone(data);
		delete newData.attachments;
		await updateData(newData);

		return { id: data.id };
	}

	async getAll(): Promise<CountryBrandApplication[]> {
		let ret = [];
		const token = localStorage.getItem("userToken");
		const res = await getAllData(token);
		if (res.ok) {
			ret = await res.json();
		} else {
			ret = [{}];
		}

		return ret;
	}
}
export { CountryBrandApplicationApiRepository };
